import {createActionGroup, emptyProps, props} from '@ngrx/store';

export const VisitPlanJobChannelActions = createActionGroup({
  source: '[VisitPlanJob/Channel]',
  events: {}
});

export const VisitPlanJobAPiActions = createActionGroup({
  source: '[VisitPlanJob/API]',
  events: {

    //Get Visit Plan Jobs
    getVisitPlanJobs: props<{ visitPlanId: string, visitPlanScheduleId?: string, params?: any }>(),
    getVisitPlanJobsSuccess: props<{ visitPlanJobs: any[], cursor?: string }>(),
    getVisitPlanJobsFailure: props<{ error: any }>(),

  }
});

export const VisitPlanJobActions = createActionGroup({
  source: '[VisitPlanJob]',
  events: {
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

